import Icon from 'vue-awesome/components/Icon'

Icon.register({
  surround_sound_rounded: {
    paths: [
      {
        d: 'M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.11 16.89c-.43.43-1.14.39-1.51-.09A7.938 7.938 0 014 12c0-1.69.53-3.38 1.59-4.8.37-.48 1.08-.53 1.51-.1.35.35.39.9.1 1.29a6.02 6.02 0 000 7.21c.3.39.26.94-.09 1.29zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm4.9.9a.978.978 0 01-.09-1.29A6.076 6.076 0 0018 12c0-1.27-.4-2.53-1.2-3.6-.3-.39-.26-.95.09-1.3.43-.43 1.14-.39 1.51.09 1.07 1.41 1.6 3.1 1.6 4.8 0 1.69-.53 3.38-1.59 4.8-.37.49-1.08.54-1.51.11zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'
      }
    ],
    width: '24',
    height: '24'
  }
})
